import React from 'react';
import {I18n} from 'react-redux-i18n';
import {withStyles, WithStyles} from '@material-ui/core/styles';

import {OperationStatus} from './constants';

import {style} from './style';

interface Props extends WithStyles<typeof style> {
  operation: string;
  status: string;
}

export const LastOperationStatusIndicator = withStyles(style)(
  ({classes, operation, status}: Props) => {
    const getStatusColor = () => {
      switch (status) {
        case OperationStatus.DONE:
          return '#4caf50'; // green
        case OperationStatus.ERROR:
          return '#f44336'; // red
        case OperationStatus.IN_PROGRESS:
          return '#ff9800'; // orange
        default:
          return '#9e9e9e'; // grey (fallback)
      }
    };

    return (
      <div
        className={classes.indicator}
        style={{
          color: getStatusColor(),
          border: `1px solid ${getStatusColor()}`,
        }}
      >
        {`${operation}: ${I18n.t(`dataExportPage.table.statuses.${status}`)}`}
      </div>
    );
  },
);
